module.exports = __webpack_public_path__ + "img/swift-boosterjet-blanco-pop.72f61a0b.png";